import React, { FC } from 'react';
import { Table, TableHead, TableCell, TableBody, TableRow, makeStyles } from '@material-ui/core';
import NumberFormat from 'components/NumberFormat';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles({
  totalRow: {
    // backgroundColor: '#f5f5f5',
    '& .MuiTableCell-root': {
      fontWeight: 'bold'
      // borderTop: '2px solid #ddd'
    }
  }
});

interface Props {
  data: InvoiceReturnModel[];
  isLoading: boolean;
}

const TablePaymentReturn: FC<Props> = props => {
  const { data, isLoading } = props;
  const classes = useStyles();

  return (
    <Table size='small' style={{ width: '100%' }}>
      <TableHead>
        <TableRow>
          <TableCell>No</TableCell>
          <TableCell>No Return</TableCell>
          <TableCell align='center'>Jumah Barang</TableCell>

          <TableCell> </TableCell>
          <TableCell align='right'> Total Return</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {isLoading ? (
          <TableRow>
            <TableCell colSpan={4}>
              <Skeleton variant='text' width='100%' height={25} />
            </TableCell>
          </TableRow>
        ) : (
          <>
            {data.length > 0 &&
              data.map((value: InvoiceReturnModel, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{value.returnNumber}</TableCell>

                  <TableCell align='center'>{value.totalItem}</TableCell>
                  <TableCell> </TableCell>
                  <TableCell align='right'>
                    <NumberFormat value={value.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
                  </TableCell>
                </TableRow>
              ))}

            {data.length > 0 && (
              <TableRow className={classes.totalRow}>
                <TableCell>TOTAL:</TableCell>
                <TableCell> </TableCell>
                <TableCell> </TableCell>
                <TableCell> </TableCell>
                <TableCell align='right'>
                  <NumberFormat
                    value={data.reduce((total, item) => total + (item.totalPrice || 0), 0)}
                    prefix={'Rp'}
                    thousandSeparator={true}
                    displayType='text'
                  />
                </TableCell>
              </TableRow>
            )}
          </>
        )}
      </TableBody>
    </Table>
  );
};

export default TablePaymentReturn;
